import { Amplify } from "aws-amplify";
import outputs from "./amplify_outputs.json";

const emailApiEndpoint =
  process.env.REACT_APP_EMAIL_API_ENDPOINT ||
  process.env.REACT_APP_EMAIL_API_URL ||
  "https://bt9f6kly45.execute-api.us-east-1.amazonaws.com/prod";

Amplify.configure({
  ...outputs,
  API: {
    REST: {
      emailapi: {
        endpoint: emailApiEndpoint.replace(/\/+$/, ""),
        region: outputs.auth.aws_region,
        authorizationType: "AWS_IAM",
      },
    },
  },
});
